<div class="main-container">
  <app-promotionpopup *ngIf="promotionPopup"></app-promotionpopup>
  <div
    [ngClass]="showTabBar ? 'tab not-full-tab tab1' : 'tab full-tab tab1'"
    id="tab1"
  >
    <app-plan></app-plan>
  </div>
  <div
    [ngClass]="showTabBar ? 'tab not-full-tab tab2' : 'tab full-tab tab2'"
    id="tab2"
  >
    <app-plans></app-plans>
  </div>
  <div
    [ngClass]="showTabBar ? 'tab not-full-tab tab3' : 'tab full-tab tab3'"
    id="tab3"
  >
    <app-cooking-story-home></app-cooking-story-home>
  </div>
  <div
    [ngClass]="showTabBar ? 'tab not-full-tab tab4' : 'tab full-tab tab4'"
    id="tab4"
  >
    <app-profile></app-profile>
  </div>
  <div
    [ngClass]="showTabBar ? 'tab not-full-tab tab5' : 'tab full-tab tab5'"
    id="tab5"
  >
    <app-blog></app-blog>
  </div>
  <div [ngClass]="showTabBar ? 'tab-bar' : 'hide-tab-bar'">
    <div class="tab-bar-button" (click)="selectTab(1)">
      <img
        *ngIf="currentTab !== 1"
        class="tab-bar-image"
        src="assets/tabBar/tab1.svg"
      />
      <img
        *ngIf="currentTab === 1"
        class="tab-bar-image"
        src="assets/tabBar/tab1Selected.svg"
      />
      <span
        *ngIf="currentTab !== 1"
        class="tab-bar-title"
        style="color: #6e6e6e"
        >روزانه</span
      >
      <span
        *ngIf="currentTab === 1"
        class="tab-bar-title"
        style="color: #0073ff"
        >روزانه</span
      >
    </div>
    <div class="tab-bar-button" (click)="selectTab(2)">
      <img
        *ngIf="currentTab !== 2"
        class="tab-bar-image"
        src="assets/tabBar/tab2.svg"
      />
      <img
        *ngIf="currentTab === 2"
        class="tab-bar-image"
        src="assets/tabBar/tab2Selected.svg"
      />
      <span
        *ngIf="currentTab !== 2"
        class="tab-bar-title"
        style="color: #6e6e6e"
        >برنامه</span
      >
      <span
        *ngIf="currentTab === 2"
        class="tab-bar-title"
        style="color: #0073ff"
        >برنامه</span
      >
    </div>
    <div class="tab-bar-button" (click)="selectTab(3)">
      <img
        *ngIf="currentTab !== 3"
        class="tab-bar-image"
        src="assets/tabBar/tab3.png"
      />
      <img
        *ngIf="currentTab === 3"
        class="tab-bar-image"
        src="assets/tabBar/tab3Selected.png"
      />
      <span
        *ngIf="currentTab !== 3"
        class="tab-bar-title"
        style="color: #6e6e6e"
        >خانه</span
      >
      <span
        *ngIf="currentTab === 3"
        class="tab-bar-title"
        style="color: #0073ff"
        >خانه</span
      >
    </div>
    <div class="tab-bar-button" (click)="selectTab(4)">
      <img
        *ngIf="currentTab !== 4"
        class="tab-bar-image"
        src="assets/tabBar/tab4.svg"
      />
      <img
        *ngIf="currentTab === 4"
        class="tab-bar-image"
        src="assets/tabBar/tab4Selected.svg"
      />
      <span
        *ngIf="currentTab !== 4"
        class="tab-bar-title"
        style="color: #6e6e6e"
        >داشبورد</span
      >
      <span
        *ngIf="currentTab === 4"
        class="tab-bar-title"
        style="color: #0073ff"
        >داشبورد</span
      >
    </div>
    <div class="tab-bar-button" (click)="selectTab(5)">
      <img
        *ngIf="currentTab !== 5"
        class="tab-bar-image"
        src="assets/tabBar/tab5.svg"
      />
      <img
        *ngIf="currentTab === 5"
        class="tab-bar-image"
        src="assets/tabBar/tab5Selected.svg"
      />
      <span
        *ngIf="currentTab !== 5"
        class="tab-bar-title"
        style="color: #6e6e6e"
        >تریبون</span
      >
      <span
        *ngIf="currentTab === 5"
        class="tab-bar-title"
        style="color: #0073ff"
        >تریبون</span
      >
      <div *ngIf="showBlogNotification" class="tab-bar-notification"></div>
    </div>
  </div>
  <app-bottomsheet
    *ngIf="showWeightBottomsheet"
    [type]="bottomsheetInput"
  ></app-bottomsheet>
  <app-plan-overview-bottomsheet
    *ngIf="planBottomSheet"
    [show]="showplanBottomSheet"
  ></app-plan-overview-bottomsheet>
  <app-calendar *ngIf="showCalendar"></app-calendar>
  <app-loading *ngIf="showLoading"></app-loading>
  <app-ios-bottomsheet
    *ngIf="showIosBottomsheet"
    [input]="iosBottomsheetInput"
  ></app-ios-bottomsheet>
  <app-tutorial *ngIf="showTutorial" [input]="tutorialInput"></app-tutorial>
  <app-report-bottomsheet
    *ngIf="showPostReport"
    [data]="bottomsheetData"
  ></app-report-bottomsheet>
</div>
